module.exports = __webpack_public_path__ + "img/icon_mail.b84f478f.svg";